/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render} from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/`, controller.index, makeLayout, render);
    router(`/dashboard`, controller.index, makeLayout, render);
};
